export const PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY = 'showPermissionsBanner';
export const IS_NEW_EMBED_QUERY_PARAM_KEY = 'isNewBlankEmbed';
